import { Para, Stack } from '@drycut/ui-components';
import { type PropsWithChildren } from 'react';
import { twJoin } from 'tailwind-merge';

type Props = PropsWithChildren<{
  disabled?: boolean;
  index: number;
}>;

export default function StepIndicator({
  children,
  index,
  disabled = false,
}: Props): React.ReactElement {
  const className = twJoin(
    'flex items-center justify-center text-white w-8 h-8 transition-all duration-500',
    disabled ? 'bg-gray-300' : 'bg-primary-600',
  );

  return (
    <Stack direction="row" gap={2}>
      <Para weight="bold" className={className}>
        {index}
      </Para>

      <Para className={disabled ? 'text-gray-400' : 'text-primary-600 font-semibold'}>
        {children}
      </Para>
    </Stack>
  );
}
